import script from "./tooltipText.vue?vue&type=script&setup=true&lang=ts"
export * from "./tooltipText.vue?vue&type=script&setup=true&lang=ts"

import "./tooltipText.vue?vue&type=style&index=0&id=38754a2b&lang=scss"

const __exports__ = script;

export default __exports__